(($) => {
  $(() => {
    const $sharingLinks = $('.sharing-links');

    if ($sharingLinks.length) {
      $sharingLinks.on('click', 'a', (e) => {
        e.preventDefault();

        const $a = $(e.currentTarget);
        const href = $a.attr('href');

        if ($a.is('.sharing-links__clipboard')) {
          navigator.clipboard.writeText(href);
        } else {
          window.open(href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');
        }
      });
    }
  });
})(jQuery);
